import { getCustomerFromCurrentHostname } from '../lib/customerFromHostname';

const DEFAULT_DATAVERSE_URL = 'https://opencareutvikling.crm19.dynamics.com';
const DEFAULT_CLIENT_ID = 'd6d038dd-a7f2-4f65-8abf-78b1ea05d484';
const DEFAULT_TENANT_ID = '643e08ad-a7f5-46c0-b072-1a48dd9c03d7';

function extractTenantFromAuthority(authority) {
  if (!authority) return '';
  const match = authority.match(/login\.microsoftonline\.com\/([^/]+)/i);
  return match ? match[1] : '';
}

export const environment = {
  deploymentMode: process.env.REACT_APP_DEPLOYMENT_MODE || 'customer',
  portalUrl: process.env.REACT_APP_PORTAL_URL || 'https://app.opencare.no',
  cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN || '',
  customerId: process.env.REACT_APP_CUSTOMER_ID || '',
  customerName: process.env.REACT_APP_CUSTOMER_NAME || '',
  dataverseUrl: process.env.REACT_APP_DATAVERSE_URL || DEFAULT_DATAVERSE_URL,
  entraClientId: process.env.REACT_APP_CLIENT_ID || DEFAULT_CLIENT_ID,
  entraTenantId:
    extractTenantFromAuthority(process.env.REACT_APP_AUTHORITY) || DEFAULT_TENANT_ID,
  accessRequestUrl:
    process.env.REACT_APP_ACCESS_REQUEST_URL || 'support@opencare.no'
};

/** Env override first, then hostname (e.g. bergen.opencare.no → bergen). */
export function getResolvedCustomerId() {
  if (environment.customerId) {
    return environment.customerId;
  }

  return getCustomerFromCurrentHostname()?.id || '';
}

export function getResolvedCustomerName() {
  if (environment.customerName) {
    return environment.customerName;
  }

  return getCustomerFromCurrentHostname()?.name || '';
}

function getPortalHostname() {
  try {
    return new URL(environment.portalUrl).hostname;
  } catch {
    return 'app.opencare.no';
  }
}

function isLocalHostBrowser() {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

function getLocalPortalPort() {
  try {
    const port = new URL(process.env.REACT_APP_PORTAL_URL || 'http://localhost:3000').port;
    return port || '3000';
  } catch {
    return '3000';
  }
}

function getBrowserPort() {
  if (typeof window === 'undefined') {
    return '';
  }

  if (window.location.port) {
    return window.location.port;
  }

  return window.location.protocol === 'https:' ? '443' : '80';
}

/** Portal when env says so, on app.opencare.no, or on localhost portal port (3000). */
export const isPortalMode = () => {
  if (environment.deploymentMode === 'portal') {
    return true;
  }

  if (isLocalHostBrowser()) {
    return getBrowserPort() === getLocalPortalPort();
  }

  if (typeof window !== 'undefined') {
    return window.location.hostname === getPortalHostname();
  }

  return false;
};

export const isCustomerMode = () => !isPortalMode();

export function getEntraAuthority() {
  return `https://login.microsoftonline.com/${environment.entraTenantId}`;
}
